import React from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Caption from '@kitconcept/volto-light-theme/components/Caption/Caption';
import cx from 'classnames';
import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const View = ({ data, properties }) => {
  const Image = config.getComponent({ name: 'Image' }).component;
  const shouldRenderCaption = properties.image_caption;

  return (
    <p
      className={cx(
        'leadimage block image align',
        {
          center: !Boolean(data.align),
        },
        properties.align,
      )}
    >
      {properties.image && (
        <>
          {(() => {
            const image = (
              <figure>
                <Image
                  className={cx({ 'full-width': data.align === 'full' })}
                  item={properties}
                  imageField="image"
                  sizes={config.blocks.blocksConfig.leadimage.getSizes(data)}
                  alt={properties.image_caption || ''}
                  loading="lazy"
                  responsive={true}
                />
                {shouldRenderCaption && (
                  <Caption credit={properties.image_caption} />
                )}
                <UniversalLink
                  className="download"
                  href={flattenToAppURL(
                    properties['@id'] + '/@@download/image',
                  )}
                >
                  Download des Bildes in hochauflösender Originalversion
                </UniversalLink>
              </figure>
            );
            if (data.href) {
              return (
                <UniversalLink
                  href={data.href}
                  openLinkInNewTab={data.openLinkInNewTab}
                >
                  {image}
                </UniversalLink>
              );
            } else {
              return image;
            }
          })()}
        </>
      )}
    </p>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
